import * as bootstrap from 'bootstrap'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollSmoother } from "gsap/ScrollSmoother.js";
import Choices from 'choices.js'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


let gsapSmoothScrollObj, scrollbarWidth

function gsapInitSmoothScroll() {
    let isDesktop

    if (window.innerWidth <= 767) {
        isDesktop = false
    } else {
        isDesktop = true
    }

    gsapSmoothScrollObj = ScrollSmoother.create({
        smooth: 0.8,
        smoothTouch: false,
        effects: isDesktop,
        ignoreMobileResize: true,
    });
}

function gsapStopSmoothScroll() {
    gsapSmoothScrollObj.kill()
}

function gsapScrollTo(elTarget, smooth = true, position = 'top 100px') {
    gsapSmoothScrollObj.scrollTo(elTarget, smooth, position)
}

function initChoicesJs() {
    const customSelect = document.querySelectorAll('.custom-form__select');

    customSelect.forEach(cs => {
        const choices = new Choices(cs, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        })
    });
}

function addClassNavbar() {
    ScrollTrigger.create({
        trigger: 'body',
        start: 'top =-50%',
        toggleClass: {
            targets: '.custom-navbar',
            className: 'scrolled'
        },
        toggleActions: 'play none none reset'
    })
}

function getScrollBarWidth() {
    scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
}

function stopSmoothScrollOnOffcanvas() {
    // stop smooth scroll when offcanvas show
    const offcanvas = document.querySelectorAll('.custom-offcanvas-js')
    const navbar = document.querySelector('.custom-navbar')

    offcanvas.forEach(oc => {
        oc.addEventListener('show.bs.offcanvas', () => {
            gsapStopSmoothScroll()
            ScrollTrigger.killAll()
            navbar.style.right = scrollbarWidth // add padding / right position because navbar position fixed
        })
        
        oc.addEventListener('hidden.bs.offcanvas', () => {
            gsapInitSmoothScroll()
            addClassNavbar()
            fadeUp()
            navbar.style.right = null
        })
    });
}

function stopSmoothScrollOnModal() {
    const modals = document.querySelectorAll('.custom-modal-js')
    const navbar = document.querySelector('.custom-navbar')

    modals.forEach(modal => {
        modal.addEventListener('show.bs.modal', () => {
            gsapStopSmoothScroll()
            ScrollTrigger.killAll()
            navbar.style.right = scrollbarWidth
            // console.log('show');
        })

        modal.addEventListener('hidden.bs.modal', () => {
            gsapInitSmoothScroll()
            addClassNavbar()
            fadeUp()
            navbar.style.right = null
            // console.log('hidden');
        })
    });
}

function fadeUp() {
    const fadeEl = gsap.utils.toArray('[tmdr-anim="fade-up"]')

    fadeEl.forEach(fe => {
        gsap.to(fe, {
            autoAlpha: 1,
            duration: 1,
            y: '0',
            ease: 'power4.out',
            stagger: 1,
            scrollTrigger: {
                trigger: fe,
                start: 'top bottom-=100',
                // markers: true,
            }
        })
    });


}

function hideTransition() {
    gsap.to('.page-transition', {
        duration: 0.3,
        autoAlpha: 0,
    })
}

gsapInitSmoothScroll()

window.addEventListener('load', () => {
    hideTransition()
    getScrollBarWidth()
    stopSmoothScrollOnOffcanvas()
    addClassNavbar()
    fadeUp()
})

export { bootstrap }

export { gsap }

export { ScrollTrigger }

export { stopSmoothScrollOnOffcanvas }

export { stopSmoothScrollOnModal }

export { gsapStopSmoothScroll }

export { gsapSmoothScrollObj }

export { gsapScrollTo }

export { initChoicesJs }